<template>
  <div>
    <div class="component-roomtypes">

      <div class="panel position-relative panel-content">
        <Breadcrumb :items=breadCrumbs() v-if="loaded"/>
        <div class="list d-none d-md-block left-edge">
          <p class="head-line justify-content-between">
            <span>{{ $t('pages.projects.title') }}</span>
            <search-filter
              v-model="filter" :disabled="!loaded || pending"
              :placeholder="$t('pages.projects.filter-tip')"
            />
            <spinner v-if="!loaded"/>
          </p>
          <div class="position-relative-w-100">
            <p class="txt-red">
              {{ $t('pages.projects.rules.camel-case') }}
              <span class="bold txt-bold">{{ $t('pages.projects.rules.camel-case-eg') }}</span>
            </p>
          </div>
          <div class="plans-table" v-if="loaded">
            <table class="w-100">
              <thead>
                <tr>
                  <th class="w-id">{{ $t('id') }}</th>
                  <th class="w-id">{{ $t('pages.projects.headers.key') }}</th>
                  <th class="w-name">{{ $t('pages.projects.headers.name') }}</th>
                  <th class="w-occupancy text-center">{{ $t('pages.projects.headers.description') }}</th>
                  <th class="w-actions">{{ $t('actions') }}</th>
                </tr>
              </thead>

              <tbody v-if="filteredProjects.length === 0 && loaded">
                <tr>
                  <td colspan="5" class="w-empty">{{ $t('pages.projects.no-projects') }}</td>
                </tr>
              </tbody>
              <tbody v-for="row in filteredProjects" :key="row.id">
                <tr class="separator before"></tr>
                <tr>
                  <td>
                    {{ row.id }}
                  </td>
                  <td>
                    {{ row.key }}
                  </td>
                  <td>
                    <p>{{ row.name }}</p>
                  </td>
                  <td class="text-center">
                    {{ row.description }}
                  </td>
                  <td class="actions">
                    <b-btn class="btn-icon btn-tiny" @click="projectTranslationsUrl(row.id)">
                      <icon width="19" height="19" type="globe"
                            v-b-tooltip:page-channels.bottom="$t('pages.projects.tooltips.project-all-translations')"
                      />
                    </b-btn>
                  </td>
                </tr>
                <tr class="separator after"></tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="d-md-none list-item" v-if="noProjects">
          <div class="w-empty">{{ $t('pages.roomtypes.no-rooms') }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

  <script>
  import { mapActions, mapGetters, mapState } from 'vuex';

  export default {
    name: 'Projects',
    props: {
      payload: {
        validator: (v) => ['object', 'undefined'].includes(typeof v),
        default: null,
      },
    },
    data: () => ({
      project: {},
      filter: '',
    }),
    async created() {
      await this.fetchData(true);
    },
    computed: {
      ...mapGetters('projects', ['loaded', 'noProjects', 'projects']),
      ...mapGetters('user', ['isAdmin', 'isDeveloper', 'isTranslator']),
      ...mapState('projects', ['error', 'pending', 'updatePending']),

      filteredProjects() {
        const filter = this.filter.trim().toLowerCase();
        let ret = this.projects;
        if (filter) {
          ret = ret.filter(({ id, name }) => (`${id}`.includes(filter) || name.toLowerCase().includes(filter)));
        }
        return ret;
      },
    },
    methods: {
      ...mapActions('projects', ['fetchData']),

      projectTranslationsUrl(projectId) {
        this.$router.push({
          name: 'automateddeepltranslations-project',
          params: { id: projectId },
        });
      },
      breadCrumbs() {
        return [
          {
            text: this.$t('pages.dashboard.title'),
            to: { name: 'dashboard' },
          },
          {
            text: this.$t('pages.projects.title'),
            active: true,
          },
        ];
      },
    },
  };
  </script>
